/*
 *  This component should ideally re-use the Dropdown component, but the dropdown component would require some tweaks
 *  The many of the styles between this and dropdown are duplicative
 */

import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'app/components/common/checkbox';
import Icon     from 'app/components/common/icon';

class MultiSelect extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.refRoot = React.createRef();

    this.onClickDocument = this.onClickDocument.bind(this);
    this.onClickInput = this.onClickInput.bind(this);
    this.onChangeOpt = this.onChangeOpt.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.onClickDocument);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onClickDocument);
  }

  onClickDocument(event) {
    const rootEl = this.refRoot.current;
    if (!rootEl) return;
    if (!event.target) return;
    const isOutside = !rootEl.contains(event.target);
    if (isOutside) {
      this.setState({isOpen: false});
    }
  }

  onClickInput() {
    this.setState((prevState) => {
      return {isOpen: !prevState.isOpen};
    });
  }

  onChangeOpt(event) {
    const optVal = event.target.value;
    const checked = event.target.checked;
    const set = new Set(this.props.value || []);
    const fn = checked ? 'add' : 'delete';
    set[fn](optVal);
    this.props.onSelect([...set]);
  }

  renderMenu() {
    if (!this.state.isOpen) return null;
    const {options, value: vals} = this.props;

    return (
      <div className="multi-select-menu">
        {options.map((opt) => {
          const isSelected = !!(vals || []).find(v => opt.value === v);
          return (
            <label className="multi-select-menu-opt" key={opt.value}>
              <Checkbox checked={isSelected} onChange={this.onChangeOpt} value={opt.value} />
              {opt.label}
            </label>
          );
        })}
      </div>
    );
  }

  render() {
    const {isOpen} = this.state;
    const {className, placeholder, small, options} = this.props;
    const vals = this.props.value || [];
    const hasValue = !!vals.length;
    const smallClass = small ? 'small' : '';
    const openClass = isOpen ? 'open' : 'closed';

    return (
      <div className={`multi-select ${className} ${openClass} ${smallClass}`} ref={this.refRoot}>
        <div className="multi-select-input" onClick={this.onClickInput}>
          {hasValue ? (<>
            {vals.map((val, i) => {
              const label = options.find(o => o.value === val)?.label || val;
              return (
                <div className="multi-select-input-val" key={i}>
                  {label}
                </div>
              );
            })}
          </>) : (<>
            <div className="multi-select-input-placeholder">{placeholder}</div>
          </>)}
          <Icon.Caret className="multi-select-input-caret" direction={isOpen ? 'up' : 'down'} />
        </div>
        {this.renderMenu()}
      </div>
    );
  }

}

MultiSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  small: PropTypes.bool,
};
MultiSelect.defaultProps = {
  className: '',
  placeholder: 'Select one or more options...',
  small: false,
};

export default MultiSelect;
